// extracted by mini-css-extract-plugin
export default {"container":"PatientView_container__nfgiL"};